import { createClient } from '@nexply/api-client';

// Same-origin: Fastify liefert das SPA aus und stellt die API unter /api bereit.
// Lokal (vite dev) zeigt VITE_API_URL sonst auf den API-Devserver.
const baseUrl = (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:3000/api';

export const api = createClient(baseUrl);
